import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AppRoutes from "./routes/routes"; // Assuming you have routes set up
import { AuthProvider } from "./contexts/AuthContext";
import { OnboardingProvider } from "./contexts/OnboardingContext";
import OnboardingTour from "./components/Layout/Onboarding/OnboardingTour";
import authService from "./services/authService";
import ErrorBoundary from "./contexts/errorBoundry";
import { clearStoredSession, updateStoredTokens } from "./shared/authSession";

const theme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          "@media (max-width: 600px)": {
            margin: "0",
            width: "95%",
            maxWidth: "95%",
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          "@media (max-width: 600px)": {
            padding: "8px 10px",
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          "@media (max-width: 600px)": {
            padding: "8px 10px",
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          "@media (max-width: 600px)": {
            padding: "8px 10px",
          },
        },
      },
    },
  },
});


function App() {
  useEffect(() => {
    const newToken = async () => {
      try {
        const response = await authService.refreshToken();
        if (response?.status === 200 || response?.data?.status === true) {
          updateStoredTokens({
            accessToken: "session-present",
            refreshToken: "session-present",
          });
          // console.log("Token refreshed at:", new Date().toLocaleTimeString());
        }
      } catch (error) {
        console.error("Error refreshing token:", error);
        if (error?.response?.status === 401) {
          clearStoredSession();
        }
      }
    };

    const refreshIntervalId = window.setInterval(newToken, 3480000);

    return () => window.clearInterval(refreshIntervalId);
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename="/">
          <OnboardingProvider>
            <ErrorBoundary>
              <AppRoutes />
              <OnboardingTour />
            </ErrorBoundary>
          </OnboardingProvider>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
